import PageNotFound from '@/components/elements/PageNotFound/PageNotFound'
import React from 'react'

const Geomembranes = () => {
    return (
        <>

            <PageNotFound />
        </>
    )
}

export default Geomembranes